import React from 'react';
import config from '../config/config';

const ICON_URLS = {
  star: `${config.icons.baseUrl}${config.icons.star}`,
  store: `${config.icons.baseUrl}${config.icons.store}`,
  school: `${config.icons.baseUrl}${config.icons.school}`,
  hotel: `${config.icons.baseUrl}${config.icons.hotel}`,
  directionsBus: `${config.icons.baseUrl}${config.icons.directionsBus}`,
};

// カテゴリーをセクションごとに分類
const categorySections = {
  recommended: {
    title: 'おすすめ',
    icon: ICON_URLS.star,
    items: [
      { label: '駅', categoryName: '駅', type: 'station' },
      { label: 'トイレ', categoryName: 'トイレ', category: 'M16010' },
      { label: 'コンビニ', categoryName: 'コンビニ', category: 'M02005' },
      { label: 'コーヒー', categoryName: 'コーヒー', category: 'M01012' },
      { label: 'スーパー', categoryName: 'スーパー', category: 'M02002' },
      { label: '公園', categoryName: '公園', category: 'M04010' },
      { label: '銀行', categoryName: '銀行', category: 'M18004' },
      { label: '病院', categoryName: '病院', category: 'M09016' },
      { label: '宿泊施設', categoryName: '宿泊施設', category: 'M05001,M05002,M05004,M05006,M05005' },
      { label: '飲食店', categoryName: 'グルメ', category: 'M01001,M01005,M01006,M01007,M01008,M01009,M01010,M01015,M01018,M01023,M01024,M01025,M01026,M01027,M01030,M01011,M01002,M01021,M01014,M01004,M01022,M01028' },
      { label: 'ラーメン', categoryName: 'ラーメン', category: 'M01002' },
      { label: '100円ショップ', categoryName: '100円ショップ', category: 'M02032' },
    ]
  },
  leisure: {
    title: 'レジャー・エンタメ・カルチャー',
    icon: ICON_URLS.star,
    items: [
      { label: '日帰り温泉', categoryName: '日帰り温泉', category: 'M09028' },
      { label: '温泉', categoryName: '温泉', category: 'M09028' },
      { label: '神社・寺院・仏閣', categoryName: '神社仏閣', category: 'M06005' },
      { label: '道の駅', categoryName: '道の駅', category: 'M08003' },
      { label: '世界遺産', categoryName: '世界遺産', category: 'M06002' },
      { label: '映画館', categoryName: '映画館', category: 'M03002' },
      { label: '漫画喫茶', categoryName: '漫画喫茶', category: 'M03009' },
      { label: '美術館', categoryName: '美術館', category: 'M04003' },
      { label: '博物館', categoryName: '博物館', category: 'M04004' },
      { label: '水族館', categoryName: '水族館', category: 'M04009' },
      { label: '動物園', categoryName: '動物園', category: 'M04006' },
      { label: '図書館', categoryName: '図書館', category: 'M13006' },
    ]
  },
  lifeService: {
    title: '生活サービス・ショッピング',
    icon: ICON_URLS.store,
    items: [
      { label: '郵便局', categoryName: '郵便局', category: 'M13001' },
      { label: '警察', categoryName: '警察', category: 'M13003' },
      { label: '公共施設', categoryName: '公共施設', category: 'M13' },
      { label: '官公庁', categoryName: '官公庁', category: 'M14' },
      { label: '100円ショップ', categoryName: '100円ショップ', category: 'M02032' },
      { label: 'ドラッグストア', categoryName: 'ドラッグストア', category: 'M02021' },
      { label: 'ホームセンター', categoryName: 'ホームセンター', category: 'M02003' },
      { label: 'モール', categoryName: 'モール', category: 'M02004' },
      { label: 'デパート', categoryName: 'デパート', category: 'M02001' },
    ]
  },
  school: {
    title: '学校',
    icon: ICON_URLS.school,
    items: [
      { label: '小学校', categoryName: '小学校', category: 'M11006' },
      { label: '中学校', categoryName: '中学校', category: 'M11005' },
      { label: '高校', categoryName: '高校', category: 'M11004' },
      { label: '高専', categoryName: '高等専門学校', category: 'M11003' },  // data-category-nameは「高等専門学校」
      { label: '大学', categoryName: '大学', category: 'M11001' },
      { label: '短大', categoryName: '短大', category: 'M11002' },
    ]
  },
  accommodation: {
    title: '宿泊',
    icon: ICON_URLS.hotel,
    items: [
      { label: 'ホテル', categoryName: 'ホテル', category: 'M05001' },
      { label: 'ビジネスホテル', categoryName: 'ビジネスホテル', category: 'M05002' },
      { label: '旅館', categoryName: '旅館', category: 'M05004' },
    ]
  },
  transportation: {
    title: '交通',
    icon: ICON_URLS.directionsBus,
    items: [
      { label: '地点・信号交差点', categoryName: '地点名', category: 'M12010' }, // 検索名は「地点名」
      { label: 'バス停', categoryName: 'バス停', category: 'M12001' },
      { label: '駐車場', categoryName: '駐車場', category: 'M08002' },
      { label: 'ガソリンスタンド', categoryName: 'ガソリンスタンド', category: 'M08004' },
      { label: 'EV充電スタンド', categoryName: 'EV充電スタンド', category: 'M08036' },
      { label: 'IC', categoryName: 'IC', category: 'M08010' },
      { label: '首都高出入口', categoryName: '首都高', category: 'M08014' }, // 検索名は「首都高」
      { label: '空港', categoryName: '空港', category: 'M12003' },
      { label: 'フェリー乗り場', categoryName: 'フェリーターミナル', category: 'M12005' }, // 検索名は「フェリーターミナル」
      { label: 'レンタカー', categoryName: 'レンタカー', category: 'M08001' },
    ]
  },
};

/**
 * カテゴリー検索コンポーネント（もっと見るボタンで表示）
 */
const CategorySearchModal = ({
  onCloseCategorySearchModal,
  handleCategorySelection
}) => {

  // オーバーレイ（背景）自身が押された時だけ閉じる
  // e.target: 実際に押された要素
  // e.currentTarget: ハンドラを付けた要素（=オーバーレイ）
  const handleOverlayPointerDown = (e) => {
    const clickedOverlayItself = (e.target === e.currentTarget);
    if (!clickedOverlayItself) {
      return;
    }
    onCloseCategorySearchModal();
  };

  return (
    <div
      className="category-search-modal-overlay"
      // 背景クリック時にonCloseを呼び出して閉じる
      onPointerDown={handleOverlayPointerDown}
    >

      <div className="category-search-modal">
        {/* 右上の閉じるボタン &times; はHTMLの特殊文字で「×」記号（掛ける、閉じるの意味） */}
        <span className="category-search-modal-close"
          onClick={onCloseCategorySearchModal}>&times;</span>

        <div className="category-search-sections">

          {/* カテゴリセクションを動的に生成 */}
          {Object.entries(categorySections).map(([key, section]) => (
            <div key={key} className="category-search-section">
              <h3>
                <i className="svg-icon-blue" style={{ backgroundImage: `url('${section.icon}')` }}></i>
                {section.title}
              </h3>
              {/* カテゴリのリストをもとに、1カテゴリごとにボタン生成 */}
              <div className="category-search-grid">
                {section.items.map((item, idx) => (
                  // ボタン表示、labelはカテゴリ名
                  <button
                    key={idx}
                    // cssでスタイル当てるため
                    className="category-search-item"
                    data-type={item.type}
                    data-category={item.category}
                    onClick={() => {
                      // クリック時、親コンポーネントにカテゴリ名・カテゴリコード・タイプを渡して、検索や状態更新を行う
                      // 検索時にもcategoryNameを優先する
                      handleCategorySelection(item.categoryName || item.label, item.category, item.type);
                      onCloseCategorySearchModal();
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div >
  );
};

export default CategorySearchModal;